import { useQuery } from '@tanstack/react-query'

import { QueryKeys } from '@/app/_utils/react-query'

import { fetchThirdPartyScriptsConfig } from './fetch-third-party-scripts-config'
import { ThirdPartyScriptData } from './response-data-validator'

export function useThirdPartyScriptsConfig() {
    return useQuery<ThirdPartyScriptData>({
        queryKey: QueryKeys.ThirdPartyScripts.Config,
        queryFn: () => fetchThirdPartyScriptsConfig(false),
        staleTime: Infinity,
        refetchOnMount: false,
    })
}
